import State from 'interfaces/state/State';

export const isLoading$ = (state: State): boolean => state.downloadFile.isLoading;
export const isError$ = (state: State): boolean => state.downloadFile.isError;
